import React, { useMemo, useState, useEffect } from "react"

//import components
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Button,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
} from "reactstrap"
import { FaEdit, FaStreetView } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/DataTableContainer"
import { getLuckyDrawUser } from "../../redux/actions/user"

const LuckyDrawUserList = () => {
  document.title = "Lucky Draw Users List"

  const history = useNavigate()
  const dispatch = useDispatch()

  const userState = useSelector(state => state.user)

  const [userData, setUserData] = useState([])
  const columns = useMemo(
    () => [
      {
        header: "Full Name",
        accessorKey: "full_name",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "email_id",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Mobile",
        accessorKey: "mobile_no",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Form",
        accessorKey: "form_id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Area",
        accessorKey: "area",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Created At",
        accessorKey: "created_modified_at",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              {row.enc_user_id ? (
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => history(`/view-user/user/${row.enc_user_id}`)}
                  title="View User"
                >
                  <FaStreetView />
                </button>
              ) : (
                <span className="text-muted">—</span> // or nothing/null if you prefer
              )}
            </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(getLuckyDrawUser({}))
  }, [dispatch])

  useEffect(() => {
    if (userState && Array.isArray(userState.luckyDrawUser)) {
      setUserData(userState.luckyDrawUser)
    }
  }, [userState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 nom-title mb-0">Lucky Draw Users</h4>
          </div>
          <Button
            color="success"
            onClick={() => (window.location.href = "/ld/pbl-34-04052025")}
          >
            Go to Lucky Draw Form
          </Button>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={userData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass=" table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
    </div>
  )
}

export default LuckyDrawUserList
